import React from 'react';
import styled from 'styled-components';
import CSLTable from '../Common/CSLTable';
import EmailConfigModal from './EmailConfigModal';
import CommitteeSelectionModal from './CommitteeSelectionModal';
import { IoIosCheckboxOutline, IoIosSquareOutline, IoIosWarning } from "react-icons/io";

const EmailContainer = styled.div`
	width: 90%;
`;
const EmailInnerContainer = styled.div`
	background-color: #ffffff;
	padding: 30px;
`;
const EmailBoldLabel = styled.div`
	font-weight: 600;
	color: #595959;
	margin-top: 5px;
`;
const EmailLabel = styled.div`
	color: #595959;
	margin-top: 5px;
`;
const ConfigBtn = styled.button`
    box-sizing: border-box;
    background-color: #37ada7;
    color: #ffffff;
    border: 1px solid #37ada7;
    font-size: 13px;
    border-radius: 4px;
    padding: 5px 20px;
    cursor: pointer;
`;

const SelectedRadio = styled.div`
	background-color: #37ADA7;
	border: 1px solid #1f615e;
	padding: 5px 10px;
	color: #ffffff;
	display: inline-block;
	cursor: pointer;
`;
const UnselectedRadio = styled.div`
	background-color: #F4F4F4;
	border: 1px solid #8c8c8c;
	padding: 5px 10px;
	color: #262626;
	display: inline-block;
	cursor: pointer;
`;
const RadioBlock = styled.div`
	margin-top: 10px;
`;

class Email extends React.Component
{
	state = {email: null, variables: null, show_email_config_modal: null, content: null, general: true, section_id: null, show_committee_selection_modal: null , committeesaccess: []};

	componentDidMount()
	{
		this.setState({email: this.props.email, variables: this.props.variables, general: this.props.general, committeesaccess: this.props.committeesaccess});
	}

	componentDidUpdate(prevProps)
	{
		if (prevProps !== this.props) {
			this.setState({email: this.props.email, variables: this.props.variables, general: this.props.general, committeesaccess: this.props.committeesaccess});
		}
	}

	decideCommitteeAccessString = (committeesaccess,email_id) => {
		let enabled = [];
		let committee_ids = [];
		let string = 'all';
		let status = 'Disabled';
		
		
		for(let c of committeesaccess){
			if(c.email_id===email_id){
				committee_ids.push(c.committee_id);
				if(c.is_enabled.toString()==='1')enabled.push(c.enabled);
			}
		}
		if(committee_ids.length!==0 && enabled.length!==0){
			status = 'Enabled';
			if(committee_ids.length!==enabled.length)string='some';
		}

		//let ret = {ot: status +' for '+ string};
		//console.log("decideCommitteeAccessString,",committeesaccess,email_id,committee_ids.length,enabled.length,ret);
		return {'status': status ,'string': string};
	}
	showEmailConfigModal = (email_id) => (event) => {
		event.preventDefault();
		console.log("email_id:", email_id);
		const content = this.state.email.find((item) => {
			return item.id === email_id;
		})
		this.setState({section_id: email_id, show_email_config_modal: true, content});
	}

	modifyEmails = (content) => {
		console.log("content:", content);
		let {email} = this.state;
		let newemail = [];
		email.forEach((item) => {
			if (item.id === content.id) {
				item = content;
				console.log("matched", item);
			}
			newemail.push(item);
		})
		console.log("emails:", newemail);
		this.props.updateEmail(newemail);
		this.setState({email: newemail, show_email_config_modal: null});
	}
	modifyEmailsAccess = (obj) => {
		this.props.updateCommitteeEmailAccess(obj);
		this.setState({show_committee_selection_modal: null});
	}

	closeModal = () => {
		this.setState({show_email_config_modal: null, content: null ,show_committee_selection_modal: null});
	}

	tableData = () => {
        let ret = {data: [], columns: []};
        ret.columns =[
                        {Header: 'Email', accessor: 'email', minWidth: 120, headerStyle: {textAlign: 'left'}}, 
						{Header: 'Subject', accessor: 'subject', minWidth: 240, headerStyle: {textAlign: 'left'}},
						{'Header' : 'Enabled', Cell: row => (
							<div>
								   {
									   (()=> {
										   if (row.original.enabled) {
											   //return(<div style={{cursor: "pointer", fontSize:"21px", float: "right"}} onClick={this.handlenaSectionIncluded(row.original.id)}><IoIosCheckboxOutline />click</div>);
											   return(<div style={{cursor: "pointer", textAlign: "center", fontStyle: 'italic' , color: "blue"}} onClick={this.handleCommitteeSelection(row.original.id)}>{row.original.str}</div>);
										   } else {
											   //return(<div  style={{cursor: "pointer", fontSize:"21px", float: "right"}} onClick={this.handlenaSectionIncluded(row.original.id)}><IoIosSquareOutline />click</div>);
											   return(<div  style={{cursor: "pointer", textAlign: "center", fontStyle: 'italic' , color: "blue"}} onClick={this.handleCommitteeSelection(row.original.id)}>{row.original.str}</div>);
										   }
									   })()
								   }
							</div>
						 ), headerStyle:{textAlign: 'center'}},
                        {'Header' : 'Action', Cell: row => (
                           <div>
                               <ConfigBtn onClick={this.showEmailConfigModal(row.original.id)}>Configure</ConfigBtn>
                           </div>
                        ), headerStyle:{textAlign: 'left'}}];
        this.state.email.forEach((item) => {
			let rt = this.decideCommitteeAccessString(this.state.committeesaccess,item.id);
        	let elem = {id: item.id, email: item.name, subject: item.subject, enabled: item.enabled, str: rt.status+' for '+rt.string};
        	ret.data.push(elem);
        })
        return ret;
	}
	handleCommitteeSelection = (email_id) => (event) => {
		console.log("email_id:", email_id);
		this.setState({show_committee_selection_modal: true, section_id: email_id});
	}
	handlenaSectionIncluded = (section_id) => (event) => {
		console.log("content:", section_id);
		let {email} = this.state;
		let newemail = [];
		email.forEach((item) => {
			if (item.id === section_id) {
				item.enabled = item.enabled ? false : true; 
				console.log("matched", item);
			}
			newemail.push(item);
		})
		console.log("emails:", newemail);
		this.props.updateEmail(newemail);
	}

	switchRadio = (key) => (event) => {
		event.preventDefault();
		let {general} = this.state;
		general[key] = general[key] ? false : true;
		this.props.updateGeneralSave(general);
	}

	render()
	{
		if (this.state.email === null) {
			return (
				<div>Loading...</div>
			);
		}
		return (
			<div>
			{
				(() => {
					if (this.state.show_email_config_modal !== null) {
						return (<EmailConfigModal variables={this.state.variables} content={JSON.parse(JSON.stringify(this.state.content))} modifyEmails={this.modifyEmails} closeModal={this.closeModal} />);
					}
				})()
			}
			{
				(() => {
					if (this.state.show_committee_selection_modal !== null) {
						return (<CommitteeSelectionModal email_id={this.state.section_id} modifyEmailsAccess={this.modifyEmailsAccess} closeModal={this.closeModal} committeesaccess={this.state.committeesaccess}/>);
					}
				})()
			}
			<EmailContainer>
				<EmailInnerContainer>
					<EmailBoldLabel style={{display: "inline-block"}}>Enable Email Notifications?</EmailBoldLabel>
					{
						(() => {
							if (this.state.general.email_remainder_enable) {
								return (
									<RadioBlock>
										<SelectedRadio>Yes</SelectedRadio>
										<UnselectedRadio onClick={this.switchRadio('email_remainder_enable')}>No</UnselectedRadio>
									</RadioBlock>
								);
							} else {
								return (
									<RadioBlock>
										<UnselectedRadio onClick={this.switchRadio('email_remainder_enable')}>Yes</UnselectedRadio>
										<SelectedRadio>No</SelectedRadio>
									</RadioBlock>
								);
							}
						})()
					}
				</EmailInnerContainer>
			</EmailContainer>
			<div styled={{clear:"both"}}></div>
				{
					(() => {
						if (this.state.general.email_remainder_enable) {
							return(
									<EmailContainer>
										<EmailInnerContainer>
											<EmailBoldLabel style={{display: "inline-block"}}>Emails</EmailBoldLabel>
											{/* <EmailLabel style={{display: "inline-block"}}>(inherited from Task Manager)</EmailLabel> */}
											<CSLTable add={false} processData={this.tableData} headerText={''} tableRows="10" refreshCallback={this.refreshState} />
										</EmailInnerContainer>
									</EmailContainer>
								)
							
						}
					})()
				}			
			</div>
		);
	}
}

export default Email;